export default __webpack_public_path__ + "static/media/Landing_Pendent.35241dcd.png";